<!-- Contenido -->
<div class="credencial-wrapper" *ngIf="flagDataGecros">
  <div class="credencial-container">
    <!-- Nota de uso -->
    <div class="nota-uso">
      <span class="material-icons">info</span>
      <p>
        El uso de esta credencial es personal e intransferible. Deberá presentarse junto a un documento que acredite su identidad cada vez que se utilice el servicio. Deberá utilizarse dentro del período de vigencia.
      </p>
    </div>

    <!-- Tarjeta de credencial (sin cambios en su estructura interna) -->
    <div class="container-credencial m-4">
      <div class="sleeve">
        <div
          class="credencial selected"
          *ngFor="let Image of credencialImg"
          [ngClass]="{ expired: isExpired }"
          [style.background-image]="'url(' + Image.credencial + ')'"
          style="background-position: center; background-repeat: no-repeat; background-size: 100% 100%; position: relative;"
        >
          <!-- Badge de vencida -->
          <div *ngIf="isExpired" class="badge-expired" aria-label="Credencial vencida">
            VENCIDA
          </div>

          <img
            *ngIf="isSantaFe"
            src="assets/img/credencial/femesfe.png"
            alt="FEMESFE"
            class="femesfe-overlay"
          />

          <!-- Logo -->
          <div class="logo-container">
            <img [src]="Image.logo" alt="Logo" class="logo" />
          </div>

          <!-- Nombre -->
          <div class="nombre-container">
            <span class="nombre">{{ afiliadoFromGecros?.nombreAfiliado }}</span>
          </div>

          <!-- Campos -->
          <div class="campos-container">
            <div class="campo">
              <span class="campo-texto">Número de Afiliado:</span>
              <span class="campo-valor">{{ numeroAfiliado }}</span>
            </div>
            <div class="campo">
              <span class="campo-texto">DNI:</span>
              <span class="campo-valor">{{ afiliadoFromGecros?.documento }}</span>
            </div>
            <div class="campo">
              <span class="campo-texto">Plan:</span>
              <span class="campo-valor">{{ afiliadoFromGecros?.plan }}</span>
            </div>
            <div class="campo">
              <span class="campo-texto">Válido hasta:</span>
              <span class="campo-valor">{{ currentDate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Patologías: lista siempre visible -->
    <div class="patologias-section">
      <h3 class="patologias-title">
        <span class="material-icons">healing</span>
        Patologías
      </h3>

      <ng-container *ngIf="user?.patologias?.length; else sinPatologias">
        <ul class="patologias-lista">
          <li class="patologia-item" *ngFor="let patologia of user.patologias">
            <span class="material-icons">circle</span>
            <span>{{ patologia }}</span>
          </li>
        </ul>
      </ng-container>
      <ng-template #sinPatologias>
        <p class="no-patologias">No se encontraron patologías registradas</p>
      </ng-template>
    </div>

    <!-- Callout de cobertura -->
    <div
      class="cobertura-card"
      [ngClass]="{
        'cobertura-ok': afiliadoFromGecros?.estado === estados[0],
        'cobertura-bad': afiliadoFromGecros?.estado !== estados[0]
      }"
    >
      <div class="cobertura-header">
        <h5>{{ afiliadoFromGecros?.estado }}</h5>
        <span class="material-icons" *ngIf="afiliadoFromGecros?.estado === estados[0]">check_circle</span>
        <span class="material-icons" *ngIf="afiliadoFromGecros?.estado !== estados[0]">cancel</span>
      </div>
      <p class="cobertura-detalle">{{ afiliadoFromGecros?.coberturas }}</p>
    </div>

    <!-- Footer informativo -->
    <p class="sss-footer">
    Superintendencia de Servicios de Salud - Órgano de control 0800-222-SALUD (72583) -
        <a href="https://www.argentina.gob.ar/sssalud" target="_blank" rel="noopener">https://www.argentina.gob.ar/sssalud</a>
    </p>
  </div>
</div>